import React, { useEffect, useState } from 'react'
import { Modal } from 'antd';
import { Button, FormContext, FormSubmitButton, FormTextArea, MasterDetailForm, Row } from '@digital/ui';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { modalAcoesIdState, ordemCompraIdState, reloadWidgetTimelineState, reloadDadosGeraisState, stepState, vendorListDocsState } from '../atoms'
import { desobrigarDdiFornecedor } from '@app/api/sas/ordemCompra';
import { ISasPropostaOrdemCompraDocs } from '@app/api/sas/sasProposta';
import { isObjNotEmpty, vtObjToFormData } from '@app/helpers/objHelper';
import { UploadFile, Visibility } from '@app/components';
import * as Yup from 'yup';
import { IArquivo } from '@app/types/core.types';
import { EStatusEtapaFluxoProcesso } from '@app/enums/EStatusEtapaFluxoProcesso';

const ButtonModalDesobrigarDdi = () => {
    const setModalAcoesId = useSetRecoilState(modalAcoesIdState);
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [exibirModal, setExibirModal] = useState(false);
    const vendorListDocs = useRecoilValue(vendorListDocsState);
    const [doc, setDoc] = useState<ISasPropostaOrdemCompraDocs>({} as ISasPropostaOrdemCompraDocs);
    const [reloadWidgetTimeline, setReloadWidgetTimeline] = useRecoilState(reloadWidgetTimelineState);
    const [reloadDadosGerais, setReloadDadosGerais] = useRecoilState(reloadDadosGeraisState);
    const step = useRecoilValue(stepState);
    useEffect(() => {
        var doc = vendorListDocs.find(f => f.id == ordemCompraId);
        if (isObjNotEmpty(doc)) {
            setDoc(doc || {} as ISasPropostaOrdemCompraDocs);
        }
    }, [exibirModal]);

    const handleCancel = () => {
        setExibirModal(false);
    };

    const handleCancelAndClose = () => {
        setExibirModal(false);
        setModalAcoesId('');
    };

    const handleSubmit = (values: any) => {
        const form = vtObjToFormData(values);
        form.append('OrdemCompraId', ordemCompraId)

        desobrigarDdiFornecedor(form)
            .then((data: any) => {
                if (data && data.valid) {
                    handleCancelAndClose();
                    setReloadWidgetTimeline(!reloadWidgetTimeline);
                    setReloadDadosGerais(!reloadDadosGerais);
                }
            });
    };

    return (
        <>
            <Button
                title='Desobrigar DDI'
                type='danger'
                disabled={step.statusEtapaFluxoProcessoId == EStatusEtapaFluxoProcesso.Concluido.id}
                onClick={() => {
                    Modal.confirm({
                        title: 'Deseja desobrigar a DDI?',
                        content:
                            '',
                        cancelText: 'Cancelar',
                        okText: 'Confirmar',
                        onOk: () => {
                            setExibirModal(true);
                        },
                    });
                }}
            />
            <Visibility visible={exibirModal}>

                <Modal
                    title={`Desobrigar DDI`}
                    width='780px'
                    visible={exibirModal}
                    onCancel={handleCancel}
                    footer={null} >
                    <Visibility visible={exibirModal} >
                        <MasterDetailForm
                            key={`formEnvioDesobrigarDdi_${ordemCompraId}`}
                            actions={[
                                <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                                <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />

                            ]}
                            initialValues={''}
                            validationSchema={
                                Yup.object().shape({
                                    justificativa: Yup.mixed().required('É necessário justificar a ação.'),
                                    arquivo: isObjNotEmpty(doc) && doc.anexoDesobrigarDDI ? Yup.mixed().notRequired() : Yup.mixed().required('É necessário anexar um arquivo.'),
                                })
                            }
                        >
                            <FormContext.Consumer>
                                {({ formProps }) => (
                                    <>
                                        <Row>


                                            <FormTextArea
                                                name='justificativa'
                                                label='Justificativa'
                                                span={12}
                                            />


                                        </Row>
                                        <br></br>
                                        <Row>
                                            <UploadFile
                                                idDoComponente='arquivo-ModalDesobrigarDdi'
                                                type='primary'
                                                hasFile={false}
                                                hasLabel={true}
                                                icon='ui-upload'
                                                span={6}
                                                onGetArquivo={() => {

                                                    if (isObjNotEmpty(doc.anexoDesobrigarDDI)) {
                                                        return Promise.resolve({
                                                            id: doc.anexoDesobrigarDDI.id,
                                                            nome: doc.anexoDesobrigarDDI.nome,
                                                            status: "",
                                                            statusArquivoId: doc.anexoDesobrigarDDI.statusArquivoId || "",
                                                        } as IArquivo);
                                                    }
                                                    return Promise.resolve(undefined);

                                                }}
                                                showDownload={true}
                                            />
                                        </Row>
                                    </>
                                )}
                            </FormContext.Consumer>

                        </MasterDetailForm>
                    </Visibility>
                </Modal>

            </Visibility>
        </>
    )
}

export default ButtonModalDesobrigarDdi